import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AdminService } from '../../admin.service';
import { TicketsComponent } from '../tickets.component';

@Component({
  selector: 'app-create-new-ticket',
  templateUrl: './create-new-ticket.component.html',
  styleUrls: ['./create-new-ticket.component.scss']
})
export class CreateNewTicketComponent implements OnInit {
  quoteList: any;
  selectedQuoteNo : any;
  ticketType: any;
  createTicketForm: FormGroup;
  selectedQuoteDetails: any;
  formdata: FormData;
  uploadedFileName: any;
  isSubmitted: boolean;
  showLoader: boolean;
  techSupport: boolean;

  constructor(private toastr: ToastrService, private dialogRef: MatDialogRef<TicketsComponent>,private _formBuilder: FormBuilder,private httpClient: HttpClient, private adminService: AdminService) { }

  ngOnInit(): void {
    this.quoteList = [];
    this.selectedQuoteNo = '';
    this.formCreate();
  }

  // getCustomerOrderQuoteList() {
  //   this.adminService.getCustomerOrderQuoteNoList(0).subscribe((response:any)=>{
  //     this.quoteList = response.data[0].list;     
  //     this.showLoader = false;
  //   },
  //   error => {
  //     this.showLoader = false;
  //     this.toastr.error(error.error.message, 'Error');
  //   });
  // }

  getPartnerOrderQuoteList() {
    this.adminService.getPartnerOrderQuoteNoList(0).subscribe((response:any)=>{
      this.quoteList = response.data[0].list;     
      this.showLoader = false;
    },
    error => {
      this.showLoader = false;
      this.toastr.error(error.error.message, 'Error');
    });
  }

  changeQuoteNumber(value) {
    console.log(this.selectedQuoteNo)
    this.quoteList.map(item=>{
      if(item.quotationId == this.selectedQuoteNo) {
        this.selectedQuoteDetails = item;
      }
    })
  }

  changeTicketType(value) {
    this.techSupport = false;    
    if(value == 'Technical Support') {
      this.ticketType = value;
      this.createTicketForm.get('quoteNumber').clearValidators();
      this.createTicketForm.get('quoteNumber').updateValueAndValidity();
      this.techSupport = true;
    } else if(value == 'Partner Order') {
      this.ticketType = value;
      this.createTicketForm.get('quoteNumber').setValidators([Validators.required]);
      this.createTicketForm.get('quoteNumber').updateValueAndValidity();
      this.showLoader = true;
      this.getPartnerOrderQuoteList();
    } else {
      this.ticketType = value;
      this.quoteList = [];
    }
  }

  formCreate() {
    this.createTicketForm = this._formBuilder.group({
      ticketType: ['', Validators.required],
      quoteNumber: ['', Validators.required],
      message: ['', Validators.required],
      uploadFile: ['', Validators.required]
    });
  }
  

  onFileSelected(fileInput) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      // if(fileInput.target.files[0].type == 'application/pdf') {
      // this.fileUploadLoader = true;
      const reader = new FileReader();
      reader.readAsDataURL(fileInput.target.files[0]);
      this.formdata = new FormData();
      this.formdata.append('attachement', fileInput.target.files[0]);
      this.uploadedFileName = fileInput.target.files[0].name;
    }
   }

   createTicket() {
    this.isSubmitted = true;
    if (this.createTicketForm.invalid) {
      return false;
    } else {
    this.showLoader = true;
    this.formdata.append('category', this.ticketType);
    this.formdata.append('message', this.createTicketForm.get('message').value);
    if(!this.techSupport) {
      this.formdata.append('reference_number', this.selectedQuoteDetails.code);
      this.formdata.append('assigned_user_name', this.selectedQuoteDetails.assignedUserName);
      this.formdata.append('assigned_user_id', this.selectedQuoteDetails.assignedUserId);
      this.formdata.append('quotation_id', this.selectedQuoteNo);
    }      
    this.formdata.append('status', 'Open');
    this.httpClient.post<any>(`${environment.customerUrl}api/v1/ticket`, this.formdata).subscribe((value) => {
      console.log(value)
      this.showLoader = false;
      this.dialogRef.close();
    },
      error => {
        this.showLoader = false;
        this.toastr.error(error.error.message, 'Error');
      });
    }
   }

  close() {
    this.dialogRef.close()
  }

}
